module.exports = __webpack_public_path__ + "img/6.310da7e.png";